import { PodMutatorStatusEnum } from '@cast/types-patching-engine';

export const isPodMutatorInstalled = (status?: PodMutatorStatusEnum): boolean =>
  !!status && status !== PodMutatorStatusEnum.STATUS_UNSPECIFIED;
